import { useState, useCallback, useMemo } from "react";
import FormFields from "./FormFields";
import SubmitButton from "./SubmitButton";
import SuccessMessage from "./Notification/Notification";
import { Link } from "react-router-dom";
import { adminSectionHeader } from "../../../AdminUtils/Dashboard.admin";
import axios from "axios";

export default function ServiceForm() {
  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    content: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isFormValid = useMemo(() => {
    return (
      formData.title.trim() !== "" &&
      formData.subtitle.trim() !== "" &&
      formData.content.trim() !== ""
    );
  }, [formData]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!isFormValid) return;
      //API call
      setIsLoading(true);

     try {
      const api = process.env.REACT_APP_API_URL
      await axios.post(`${api}/adm/services/add`, formData,{withCredentials:true})
        .then((response) => {
          setIsSubmitted(true);
        })
        .catch((error) => {
          return
        })
        .finally(() => {
          setIsLoading(false);
        });
     } catch (error) {
        return
     }
      
    },
    [formData, isFormValid]
  );

  return (
    <div className="service-form-container">
      <div className="form-header">
        <Link to="/admin/settings" className="back-link">
          ← Add A Service
        </Link>
      </div>

      {/* Main form card */}
      <div className="form-card">
        <div className="form-card-heading">
            {<span>
                    <i className="ri-service-line text-2xl text-green-600" style={{color:"#16a34a", fontSize:"40px"}}></i>
        </span>
        }
        {adminSectionHeader(
          "Add New Service",
          "Create a new service offering for your homepage" )}
        </div>

        {isSubmitted ? (
          <SuccessMessage />
        ) : (
          <form onSubmit={handleSubmit}>
            <FormFields formData={formData} onInputChange={handleInputChange} />
            <SubmitButton isLoading={isLoading} isDisabled={!isFormValid} />
          </form>
        )}
      </div>
    </div>
  );
}
